import React, { useState } from 'react';
import StaffCostsRow from './StaffCostsRow';
import { Col, Row, Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import TotalTableRow from './TotalTableRow';
const StaffCosts = _ref => {
  let {
    data,
    setData,
    selectedProject,
    selectedProjectId,
    emptyStaffCosts,
    removeEmptyRow
  } = _ref;
  const {
    t
  } = useTranslation();
  const tableHeadings = ['employee_name_number', 'half_year_required', 'sum_working_hr_rd', 'rel_agreed_annual_working_hrs', 'share_of_working_time', 'a1_exec_special_payment', 'a2_ a2_sum_special_payments', 'a_sum_of_a1_and_a2', 'employers_social_security', 'a_gross_wage', 'b_employers_social_secutiry_contributions', ''];
  const tableHeadingRow = tableHeadings.map((heading, i) => {
    return /*#__PURE__*/React.createElement("th", {
      key: 'th' + i,
      style: {
        width: '80px'
      }
    }, t(heading));
  });
  const tableRows = data.map(currentData => {
    return /*#__PURE__*/React.createElement(StaffCostsRow, {
      data: data,
      setData: setData,
      rowData: currentData,
      key: currentData.id,
      selectedProjectId: selectedProjectId,
      selectedProject: selectedProject
    });
  });
  const emptyRows = emptyStaffCosts.map(emptyStaffCost => {
    return /*#__PURE__*/React.createElement(StaffCostsRow, {
      key: 'createRowStaffCostList' + emptyStaffCost.emptyRowId,
      emptyRowId: emptyStaffCost.emptyRowId,
      data: data,
      setData: setData,
      selectedProject: selectedProject,
      removeEmptyRow: removeEmptyRow,
      rowData: emptyStaffCost
    });
  });
  const totalTableRow = /*#__PURE__*/React.createElement(TotalTableRow, {
    key: "totalTableRow",
    staffCostTotals: selectedProject.project_elster_detail.total_for_staff_cost
  });
  return /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    hover: true
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, tableHeadingRow)), /*#__PURE__*/React.createElement("tbody", null, tableRows, emptyRows, totalTableRow));
};
export default StaffCosts;